/**
 * This is the main entry point for the brand.
 */

import '~base'; // call the main module
import './components/mobileSearch';
